import { createContext, ReactNode } from 'react';
import utils from 'utils';

type OnboardingContextProps = {
  canUserSeeOnboarding: boolean;
  contentCard: ReactNode;
  onShowOnboarding: () => void;
  onCloseOnboarding: () => void;
};

export default createContext<Partial<OnboardingContextProps>>({
  canUserSeeOnboarding: false,
  contentCard: null,
  onShowOnboarding: utils.noop,
  onCloseOnboarding: utils.noop,
});
